import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ManufacturingAssemblyScenarioDetailsPage } from '@/areas/manufacturing-scenarios/ManufacturingScenarios/ManufacturingScenario/ManufacturingScenarioDetailsPage';
import { canViewProjectManufacturing } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity',
)({
    staticData: { access: { permissions: canViewProjectManufacturing }, chrome: 'project' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return (
        <ManufacturingAssemblyScenarioDetailsPage
            entity={'activity'}
            rfqId={pathParams.projectId}
            manufacturingAssemblyDetailsId={pathParams.manufacturingAssemblyDetailsId}
            manufacturingScenarioId={pathParams.manufacturingScenarioId}
        />
    );
}
